/**
 * Mood banner — editorial entrance motion (respects reduced motion).
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function reveal(root) {
    if (!root) return;
    root.classList.add('tcn-mood-banner--inview');
  }

  function initBanner(root) {
    if (!root || root.dataset.tcnMoodInit === '1') return;
    root.dataset.tcnMoodInit = '1';

    if (prefersReducedMotion()) {
      reveal(root);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      reveal(root);
      return;
    }

    /* Failsafe: never leave copy stuck at opacity 0 if observer never fires */
    var failsafe = window.setTimeout(function () {
      reveal(root);
    }, 1800);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            window.clearTimeout(failsafe);
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-tcn-mood-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target && event.target.querySelector
      ? event.target.querySelector('[data-tcn-mood-banner]')
      : null;
    if (el) initBanner(el);
  });
})();
